const { config } = require('../../config.js');
const getDrivers = async (auth,setLoading) => {
    
    let drivers = (await (await fetch(config.api + 'getDrivers', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            token: await auth?.currentUser?.getIdToken(),
        }),
    })).json()).drivers;

    if (setLoading) {
        setLoading(false);
    }

    return drivers;

}
export default getDrivers;